module.exports = __webpack_public_path__ + "static/media/my.263aea34.svg";